import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Navbar from "react-bootstrap/Navbar";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import Badge from "react-bootstrap/Badge";
import moment from "moment";

class GeneralInquiries extends React.Component {
  render() {
    const { inquiries } = this.props;

    return (
      <div>
        <Navbar className="bg-primary justify-content-between">
          <Navbar.Brand>
            General Inquiries <Badge variant="light">{inquiries.length}</Badge>
          </Navbar.Brand>
        </Navbar>
        <Table className="bg-flat" responsive>
          <thead>
            <tr>
              <th>Date/Time</th>
              <th>Name</th>
              <th>Message</th>
              <th>Replied</th>
              <th>Marked By</th>
              {/* <th>Deliveries This Month</th>
              <th>Awaiting Delivery</th> */}
            </tr>
          </thead>
          <tbody>
            {inquiries.map((inquiry) => (
              <tr key={inquiry.id}>
                <td>{moment(inquiry.created_at).format("MMM DD hh:mm a")}</td>
                <td>
                  {inquiry.name || ""} {inquiry.email}
                </td>
                <td>{inquiry.message || ""}</td>
                <td>
                  {" "}
                  {inquiry.responded ? (
                    moment(inquiry.marked_at).format("MMM DD hh:mm a")
                  ) : (
                    <DropdownButton id="dropdown-basic-button" title="Action">
                      <Dropdown.Item
                        onClick={() => this.props.handleEditInquiry(inquiry.id)}
                      >
                        Mark
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          this.props.handleDeleteInquiry(inquiry.id)
                        }
                      >
                        Delete
                      </Dropdown.Item>
                    </DropdownButton>
                  )}
                </td>
                <td>{inquiry.marked_by || ""}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(GeneralInquiries);
